import { useMemo } from "react";
import { bool, func, number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateStructure,
  CollapseValueInnerCell,
  ResetValueButton
} from "@tools";

export const WeekValueCell = observer(({
  value: weeklyValue=0,
  week,
  month,
  maxHours,
  hasOverride,
  readOnly,
  displayContent,
  displayCellContent,
  handleReset,
  handleValueChange,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();
  const { modifier, usedRoundDecimals } = structure.settings;
  
  const value = useMemo(() => (
    weeklyValue ? (weeklyValue / modifier) : 0
  ), [weeklyValue, modifier]);
  
  const editable = useMemo(() => (
    !readOnly && allowEdition
  ), [readOnly, allowEdition])
  
  const displayResetButton = useMemo(() => (
    hasOverride && displayContent && editable && handleReset && !readOnly
  ), [hasOverride, displayContent, editable, handleReset, readOnly])
  
  const displayedValue = useMemo(() => (
    displayCellContent && (hasOverride || value)
      ? value
      : ""
  ), [displayCellContent, hasOverride, value]);
  
  return (
    <CollapseValueInnerCell
      narrow
      value={displayedValue}
      useBorder
      max={maxHours}
      displayContent={displayContent}
      displayCellContent={displayCellContent}
      showDecimals
      editable={editable}
      textPresetClass="preset-timelineText"
      onValueChange={handleValueChange}
      decimals={usedRoundDecimals}
      inputClassName={ `input-week${week+1}` }
      navigationKey={`tm-month${month+1}-${week+1}`}
    >
      {displayResetButton && (
        <ResetValueButton action={handleReset}>
          {t("views.editor.revert_value")}
        </ResetValueButton>
      )}
    </CollapseValueInnerCell>
  )
})

WeekValueCell.propTypes = {
  week: number.isRequired,
  month: number.isRequired,
  value: number,
  maxHours: number,
  readOnly: bool,
  hasOverride: bool,
  allowEdition: bool,
  displayCellContent: bool,
  handleReset: func,
  handleValueChange: func,
}